/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Book_HintInputs */

const en_coaching_book_hint = /** @type {(inputs: Coaching_Book_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking uses one session. The Cal.com scheduler opens in a new tab.`)
};

const id_coaching_book_hint = /** @type {(inputs: Coaching_Book_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan memakai satu sesi. Penjadwal Cal.com terbuka di tab baru.`)
};

/**
* | output |
* | --- |
* | "Booking uses one session. The Cal.com scheduler opens in a new tab." |
*
* @param {Coaching_Book_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_book_hint = /** @type {((inputs?: Coaching_Book_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Book_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_book_hint(inputs)
	return en_coaching_book_hint(inputs)
});